import image1 from "/Users/nikkylu/lumed/src/pages/components/dress.fld/image001.png";
import image2 from "/Users/nikkylu/lumed/src/pages/components/dress.fld/image002.jpg";
import "./Home.css"

const Dressing = () => {
  return (
<div className="Home">
    <div>Various Surgical Dressing & Device Kits</div>

    <div className="Home-con">
        <div className="Home-s">
            <div>Surgical Drapes &amp; Draping Kits, sterile, CE</div>
            <div>Single-use SMS / non-woven drapes — fenestrated, plain, and adhesive</div>
            <div>Procedure-specific draping kits across all major surgical disciplines</div>
            <div>Various surgery kits on request</div>
        </div>
    </div>

    {/* <iframe
    width="100%"
    height="600"
    src="https://docs.google.com/spreadsheets/d/15UmxZL9BOIpro8tOV2LBn-HhOkDAaJxX/edit?usp=sharing&ouid=112775150088016192139&rtpof=true&sd=true"
    frameBorder="0"
    >
    Your browser does not support iframes.
    </iframe> */}
    <div className="Home-sl">Spontaneous Labor Kit (Natural Baby Birth Kit) </div>
    <iframe 
    width="60%"
    height="400"
    src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQaR0q_q4vylXvf47mpxLlwL7-MUKtiwT3GU-UGKNeKijKAJfvSgF2ixDA20CfnMA/pubhtml?gid=1247665769&amp;single=true&amp;widget=true&amp;headers=false">
        Your browser does not support iframes.
    </iframe>
        <div className="Home-sl">Cesarean Section Surgery Kit (Baby Birth by Surgery Kit) </div>
    <iframe 
    width="60%"
    height="400"
    src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQaR0q_q4vylXvf47mpxLlwL7-MUKtiwT3GU-UGKNeKijKAJfvSgF2ixDA20CfnMA/pubhtml?gid=187822603&amp;single=true&amp;widget=true&amp;headers=false">
        Your browser does not support iframes.
    </iframe>
    <div className="Home-sl">Dental surgery Kit</div>
    <iframe 
    width="60%"
    height="400"
    src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQaR0q_q4vylXvf47mpxLlwL7-MUKtiwT3GU-UGKNeKijKAJfvSgF2ixDA20CfnMA/pubhtml?gid=1240122664&amp;single=true&amp;widget=true&amp;headers=false">
        Your browser does not support iframes.
    </iframe>
    <div className="Home-sl">General Surgery Kit</div>
    <iframe 
    width="60%"
    height="400"
    src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQaR0q_q4vylXvf47mpxLlwL7-MUKtiwT3GU-UGKNeKijKAJfvSgF2ixDA20CfnMA/pubhtml?gid=1894733275&amp;single=true&amp;widget=true&amp;headers=false">
        Your browser does not support iframes.
    </iframe>
    <div className="Home-sl">Urology Surgery Kit</div>
    <iframe 
    width="60%"
    height="400"
    src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQaR0q_q4vylXvf47mpxLlwL7-MUKtiwT3GU-UGKNeKijKAJfvSgF2ixDA20CfnMA/pubhtml?gid=2069680933&amp;single=true&amp;widget=true&amp;headers=false">
        Your browser does not support iframes.
    </iframe>
    <div className="Home-sl">Cerebral/Brain Surgery Kit</div>
    <iframe 
    width="60%"
    height="400"
    src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQaR0q_q4vylXvf47mpxLlwL7-MUKtiwT3GU-UGKNeKijKAJfvSgF2ixDA20CfnMA/pubhtml?gid=809286304&amp;single=true&amp;widget=true&amp;headers=false">
        Your browser does not support iframes.
    </iframe>
    <div className="Home-sl">Orthopedic Surgery Kit</div>
    <iframe 
    width="60%"
    height="400"
    src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQaR0q_q4vylXvf47mpxLlwL7-MUKtiwT3GU-UGKNeKijKAJfvSgF2ixDA20CfnMA/pubhtml?gid=1381286484&amp;single=true&amp;widget=true&amp;headers=false">
        Your browser does not support iframes.
    </iframe>

    <div className="Home-sl">Ophthalmology Surgery Kit</div>
    <iframe 
    width="60%"
    height="400"
    src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQaR0q_q4vylXvf47mpxLlwL7-MUKtiwT3GU-UGKNeKijKAJfvSgF2ixDA20CfnMA/pubhtml?gid=1551454353&amp;single=true&amp;widget=true&amp;headers=false">
        Your browser does not support iframes.
    </iframe>
    <div className="Home-sl">Interventional Radiology Kit</div>
    <iframe 
    width="60%"
    height="400"
    src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQaR0q_q4vylXvf47mpxLlwL7-MUKtiwT3GU-UGKNeKijKAJfvSgF2ixDA20CfnMA/pubhtml?gid=2012054290&amp;single=true&amp;widget=true&amp;headers=false">
        Your browser does not support iframes.
    </iframe>


    </div>
    
   
  )
}

export default Dressing;